import { PageInfoFragment } from "@saleor/fragments/types/PageInfoFragment";
import { DocumentNode } from "graphql";

import makeSearch, { SearchVariables, UseSearchHook } from "./makeSearch";

export interface SearchData {
  me: {
    search: {
      edges: Array<{
        node: any;
      }>;
      pageInfo: PageInfoFragment;
    };
  };
}

function makeTopLevelSearch<
  TData extends SearchData,
  TVariables extends SearchVariables
>(query: DocumentNode): UseSearchHook<TData, TVariables> {
  return makeSearch<TData, TVariables>(query, result => {
    if (result?.data?.me.search.pageInfo.hasNextPage) {
      result.loadMore(
        (prev, next) => {
          if (
            prev.me.search.pageInfo.endCursor ===
            next.me.search.pageInfo.endCursor
          ) {
            return prev;
          }

          return {
            ...prev,
            me: {
              ...prev.me,
              search: {
                ...prev.me.search,
                edges: [...prev.me.search.edges, ...next.me.search.edges],
                pageInfo: next.me.search.pageInfo
              }
            }
          };
        },
        {
          ...result.variables,
          after: result.data.me.search.pageInfo.endCursor
        }
      );
    }
  });
}

export default makeTopLevelSearch;
